<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.tp_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="tp_emname">
            <label class="weui-form-preview__label">{{customLabel.tp_emname || "申请人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.tp_emname}}
              <call-mobile :em-id="form.main.tp_emid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="tp_department">
            <label class="weui-form-preview__label">{{customLabel.tp_department || "部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.tp_department}}</span>
          </div>
          <div class="weui-form-preview__item" slot="tp_position">
            <label class="weui-form-preview__label">{{customLabel.tp_position || "岗位"}}</label>
            <span class="weui-form-preview__value">{{form.main.tp_position}}</span>
          </div>
          <div class="weui-form-preview__item" slot="tp_type">
            <label class="weui-form-preview__label">{{customLabel.tp_type || "类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.tp_type}}</span>
          </div>
          <template v-if="form.main.tp_type=='离职'">
            <div class="weui-form-preview__item" slot="tp_indate">
              <label class="weui-form-preview__label">{{customLabel.tp_indate || "入职时间"}}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.tp_indate}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_outdate">
              <label class="weui-form-preview__label">{{customLabel.tp_outdate || "离职时间"}}</label>
              <span
                class="weui-form-preview__value"
                v-format="'yyyy-MM-dd'"
              >{{form.main.tp_outdate}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_handover">
              <label class="weui-form-preview__label">{{customLabel.tp_handover || "交接人"}}</label>
              <span class="weui-form-preview__value">{{form.main.tp_handover}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_reason">
              <label class="weui-form-preview__label">{{customLabel.tp_reason || "离职原因"}}</label>
              <span class="weui-form-preview__value">{{form.main.tp_reason}}</span>
            </div>
          </template>
          <template v-if="form.main.tp_type=='转正'">
            <div class="weui-form-preview__item" slot="tp_indate">
              <label class="weui-form-preview__label">{{customLabel.tp_indate || "入职时间"}}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.tp_indate}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_outdate">
              <label class="weui-form-preview__label">{{customLabel.tp_outdate || "转正时间"}}</label>
              <span
                class="weui-form-preview__value"
                v-format="'yyyy-MM-dd'"
              >{{form.main.tp_outdate}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_reason">
              <label class="weui-form-preview__label">{{customLabel.tp_reason || "试用期评价"}}</label>
              <span class="weui-form-preview__value">{{form.main.tp_reason}}</span>
            </div>
          </template>
          <template v-if="form.main.tp_type=='辞退'">
            <div class="weui-form-preview__item" slot="tp_indate">
              <label class="weui-form-preview__label">{{customLabel.tp_indate || "入职时间"}}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.tp_indate}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_outdate">
              <label class="weui-form-preview__label">{{customLabel.tp_outdate || "辞退时间"}}</label>
              <span
                class="weui-form-preview__value"
                v-format="'yyyy-MM-dd'"
              >{{form.main.tp_outdate}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_handover">
              <label class="weui-form-preview__label">{{customLabel.tp_handover || "交接人"}}</label>
              <span class="weui-form-preview__value">{{form.main.tp_handover}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_amount">
              <label class="weui-form-preview__label">{{customLabel.tp_amount || "补偿金额"}}</label>
              <span class="weui-form-preview__value">{{form.main.tp_amount}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_reason">
              <label class="weui-form-preview__label">{{customLabel.tp_reason || "辞退原因"}}</label>
              <span class="weui-form-preview__value">{{form.main.tp_reason}}</span>
            </div>
          </template>
          <template v-if="form.main.tp_type=='调动'">
            <div class="weui-form-preview__item" slot="tp_indate">
              <label class="weui-form-preview__label">{{customLabel.tp_indate || "入职时间"}}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.tp_indate}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_outdate">
              <label class="weui-form-preview__label">{{customLabel.tp_outdate || "调动时间"}}</label>
              <span
                class="weui-form-preview__value"
                v-format="'yyyy-MM-dd'"
              >{{form.main.tp_outdate}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_handover">
              <label class="weui-form-preview__label">{{customLabel.tp_handover || "交接人"}}</label>
              <span class="weui-form-preview__value">{{form.main.tp_handover}}</span>
            </div>
            <div class="weui-form-preview__item" slot="tp_newdepartment">
              <label class="weui-form-preview__label">{{customLabel.tp_newdepartment || "调动后部门"}}</label>
              <span class="weui-form-preview__value">{{form.main.tp_newdepartment}}</span>
            </div>
            <div class="weui-form-preview__item" slot="roles">
              <label class="weui-form-preview__label">{{customLabel.roles || "调动后岗位"}}</label>
              <span class="weui-form-preview__value">
                {{ form.main.roles.map(role => role.name).join(',') }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="tp_reason">
              <label class="weui-form-preview__label">{{customLabel.tp_reason || "调动原因"}}</label>
              <span class="weui-form-preview__value">{{form.main.tp_reason}}</span>
            </div>
          </template>
        </custom-layout>
      </div>

      <file-list v-model="form.main.tp_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/empchange_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/oa/turnposition",
      codeField: "tp_code",
      statusField: "tp_statuscode",
      caller: "TurnPosition",
      xtype: "oa-turnposition-formpanel",
    };
  }
};
</script>